import { hasFeatureFlag } from './featureFlags/hasFeatureFlag';
import { fewerProductsPerPage } from '../activeFeatureFlags';

export const getDefaultPageSize = (cookies: Record<string, string>) =>
  hasFeatureFlag(fewerProductsPerPage, cookies) ? 36 : 72;
